import { createSelector } from "reselect";
import { populationIncidencePrevalenceChartDataSelector } from "../population_incidence_prevalence_chart_data_selector";

export const populationIncidencePrevalenceChartDataDataSelector = createSelector(
  populationIncidencePrevalenceChartDataSelector,
  chartData => {
    return chartData.data;
  }
);
